namespace Gordic.Adm.WebControls.GAdmGridFunctions {
    export function createGridFormat(dataListdescriptor: General.ApplicationInterface.GDataListDescription, columnOrder: string, withoutAktivita: boolean = false, specialAktivitaColumns: string[] = []): Gordic.Data.GridFormat {
        var columns = new Gordic.Data.GridFormat();
        if (dataListdescriptor.list_fields) {
            var isInGridFormat: boolean[] = new Array(dataListdescriptor.list_fields?.length);
            for (var i = 0; i < dataListdescriptor.list_fields.length; i++) {
                isInGridFormat.push((dataListdescriptor.list_fields[0].field_visible == false) ? true : false)
            }
            if (withoutAktivita == false) {
                // Aktivita
                var aktivitaCol = dataListdescriptor.list_fields?.findIndex(col => col.field_name == "aktivita");
                if (aktivitaCol != -1) {
                    createAktivitaColumn(dataListdescriptor.list_fields[aktivitaCol], columns);
                    isInGridFormat[aktivitaCol] == true;
                }
                // Datum OD DO
                var datOd = dataListdescriptor.list_fields?.findIndex(col => (col.field_name == "dat_od"));
                var datDo = dataListdescriptor.list_fields?.findIndex(col => (col.field_name == "dat_do"));
                if (datOd != -1 || datDo != -1) {
                    createDatOdOrDoColumn(columns);
                }
                // EXPERIMENTÁLNÍ - není povolená editace
                var zamekCol = dataListdescriptor.list_fields?.findIndex(col => col.field_name == "zamek");
                if (zamekCol != -1)
                    createZamekColumn(columns)
            }
            // Ostatní sloupce podle pořadí
            var columnsStr = columnOrder.split(",")
            columnsStr.forEach((item) => {
                var colIndex = dataListdescriptor.list_fields?.findIndex(col => (col.field_name == item))
                if (colIndex != undefined && colIndex != null && colIndex != -1) {
                    if (dataListdescriptor.list_fields) {
                        if (specialAktivitaColumns.includes(item)) {
                            createAktivitaColumn(dataListdescriptor.list_fields[colIndex], columns, item);
                        } else
                            createClassicColumn(dataListdescriptor.list_fields[colIndex], columns);
                    }
                }
            })
        }
        return columns;
    }

    export function createGridGormatAuditPristupu(dataListdescriptor: General.ApplicationInterface.GDataListDescription, columnOrder: string): Gordic.Data.GridFormat {
        var columns = new Gordic.Data.GridFormat();
        createAkceColumn(columns);
        var columnsStr = columnOrder.split(",")
        columnsStr.forEach((item) => {
            var colIndex = dataListdescriptor.list_fields?.findIndex(col => (col.field_name == item))
            if (colIndex && colIndex != -1) {
                if (dataListdescriptor.list_fields)
                    createClassicColumn(dataListdescriptor.list_fields[colIndex], columns);
            }
        })
        return columns;
    }

    export function createPanelData(title: string, row: any[] | null, gridFormat: Gordic.Data.GridFormat, panelElement: JQuery<HTMLElement>, gridOptions: any ) {
        if (row === null || row === undefined || row.length === 0) {
            GridUtils.setPreviewEmpty(panelElement);
        }
        else {
            var srow: any = row.length === 1 ? row[0] : row[row.length - 1];		// v případě single první s výběru, v případě multi poslední z výběru
            var format = gridFormat;
            var columns = format.columns;
            var width = panelElement[0].clientWidth;
            var container = $("<div class='adm-sidebar-seznam js-sml {0}'>".format(width >= 500 ? "size-M" : "size-S")).appendTo(panelElement);
            var containerForm = $("<div class='form'>").appendTo(container);
            let specialAktivitaColumns: string[] = gridOptions.iconAktivitaColumns ?? [];
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].name) {
                    var formRow = $("<div class='row'>").appendTo(containerForm);
                    var caption = "";
                    var valueEl = $("<div class='value'>")
                    // První řádek aktivita
                    if (i == 0 && columns[i].name == "aktivita") {
                        valueEl.attr("style", "height:20px;");
                        caption = "jres:32131030"
                        var value = getScopedObj(srow, columns[i].name || "");
                        $("<div>").appendTo(valueEl).gbadge(Gordic.Adm.WebControls.GAdmGlobals.CreateAktivitaBadge(value))
                    } else if ((i == 1 || i == 0) && columns[i].name == "platnost") {
                        valueEl.attr("style", "height:20px;");
                        caption = "jres:33000176";
                        var value = getScopedObj(srow, "platnost");
                        $("<div>").appendTo(valueEl).gbadge(GAdmGlobals.CreatePlatnostBadge(value))
                    } else if ((i == 1 || i == 2) && columns[i].name == "zamek") {
                        valueEl.attr("style", "height:20px;");
                        caption = "jres:32000120";
                        var value = getScopedObj(srow, "zamek");
                        $("<div>").appendTo(valueEl).gbadge(GAdmGlobals.CreateEditaceBadge(value))
                    } else if (specialAktivitaColumns.includes(columns[i].name ?? "")) {
                        var selectKey = columns[i];
                        valueEl.attr("style", "height:20px;");
                        caption = selectKey.caption === undefined ? "undefined" : selectKey.caption;
                        var value = getScopedObj(srow, columns[i].name || "");
                        $("<div>").appendTo(valueEl).gbadge(Gordic.Adm.WebControls.GAdmGlobals.CreateAktivitaBadge(value))
                    } else {
                        var selectKey = columns[i];
                        var field_name = selectKey.name || "";
                        var value = getScopedObj(srow, field_name);
                        if (value != undefined) {
                            if (selectKey.columnType === "datetime") {
                                if (selectKey.formatPreset === "DMRHMS") {
                                    value = value === null ? "" : Gordic.Templates.Formatters.datetime(value, 'datetime');
                                }
                                else if (selectKey.formatPreset === "DMR") {
                                    value = value === null ? "" : Gordic.Templates.Formatters.datetime(value, 'date');
                                }
                            }
                            else if (selectKey.columnType === "boolean") {
                                value = (value == 1 || value == 10) ? "jres:33000180" : "jres:33000181"; //RC 33000181 : Ne
                            }
                        } else {
                            value = value === null ? "" : value;
                        }
                        if (typeof (value) == "string")
                            if (value.trim() == "") value = "—"
                        valueEl.html(value);
                        caption = selectKey.caption === undefined ? "undefined" : selectKey.caption;
                    }
                    $("<div class='label'>").appendTo(formRow).text("{0}:".format(caption));
                    valueEl.appendTo(formRow);
                }
            }
        }
    }

    function createAktivitaLabelColumn(column: Gordic.General.ApplicationInterface.GDataFieldDescription, gridformat: Gordic.Data.GridFormat) {
        gridformat.addHtmlColumn({
            name: column.field_name + "label" || "",
            caption: column.field_caption || "",
            cellTemplate: (row) => {
                var text = "";
                var icon = "";
                switch (row.aktivita) {
                    case 100:
                        text = "jres:33000139";
                        icon = "g-state-success"
                        break;
                    case 300:
                        text = "jres:33000142"; //RC 33000142 : Připraven
                        icon = "g-state-info";
                        break;
                    case 500:
                        text = "jres:33000140";
                        icon = "g-state-warning";
                        break;
                    case 600:
                        text = "jres:33000141" //RC 33000141 : Návrh
                        icon = "g-state-info";
                        break;
                    default:
                        text = "jres:33000143" //RC 33000143 : Zrušen
                        icon = "g-state-error"
                        break;
                }
                return $("<span>").gbadge({ customClass: icon, value: text });
            }
        })
    }

    export function createAktivitaCaptionIcon(aktivita: number): any {
        var text = "";
        var icon = "";
        switch (aktivita) {
            case 100:
                text = "jres:33000139";
                icon = "fa-check-circle g-state-text g-state-success"
                break;
            case 300:
                text = "jres:33000142"; //RC 33000142 : Připraven
                icon = "fa-exclamation-triangle g-state-text g-state-info";
                break;
            case 500:
                text = "jres:33000140";
                icon = "fa-exclamation-triangle g-state-text g-state-warning";
                break;
            case 600:
                text = "jres:33000141" //RC 33000141 : Návrh
                icon = "fa-exclamation-triangle g-state-text g-state-info";
                break;
            case 900:
                text = "jres:33000143" //RC 33000143 : Zrušen
                icon = "fa-times-circle g-state-text g-state-error";
                break;
            default:
                text = ""
                icon = ""
                break;
        }
        return { icon: icon, text: text, tooltip: text };
    }

    function createAktivitaColumn(column: Gordic.General.ApplicationInterface.GDataFieldDescription, gridformat: Gordic.Data.GridFormat, aktivitaFieldName: string = "aktivita") {
        //gridformat.addHtmlColumn({
        //    name: column.field_name || "",
        //    caption: column.field_caption || "",
        //    cellTemplate: (row) => {
        //        var badge = $("<span>");
        //        var text = "";
        //        var icon = "";
        //        var customclass = "";
        //        switch (row.aktivita) {
        //            case 100:
        //                text = "jres:33000139";
        //                icon = "fa-check-circle g-state-text g-state-success"
        //                customclass = "g-state-success"
        //                break;
        //            case 300:
        //                text = "jres:33000142"; //RC 33000142 : Připraven
        //                icon = "fa-exclamation-triangle g-state-text g-state-info";
        //                customclass = "g-state-info"
        //                break;
        //            case 500:
        //                text = "jres:33000140";
        //                icon = "fa-exclamation-triangle g-state-text g-state-warning";
        //                customclass = "g-state-warning"
        //                break;
        //            case 600:
        //                text = "jres:33000141" //RC 33000141 : Návrh
        //                icon = "fa-exclamation-triangle g-state-text g-state-info";
        //                customclass = "g-state-info"
        //                break;
        //            default:
        //                text = "jres:33000143" //RC 33000143 : Zrušen
        //                icon = "fa-times-circle g-state-text g-state-error"
        //                customclass = "g-state-error"
        //                break;
        //        }
        //        badge.gbadge({
        //            value: text,
        //            customClass: customclass
        //        })
        //        return badge;
        //    }
        //})

        gridformat.addIconColumn({
            name: column.field_name || "",
            caption: column.field_caption || "",
            iconTemplate: (row) => {
                return Gordic.Adm.WebControls.GAdmGridFunctions.createAktivitaCaptionIcon(row[aktivitaFieldName]);
                //var text = "";
                //var icon = "";
                //switch (row.aktivita) {
                //    case 100:
                //        text = "jres:33000139";
                //        icon = "fa-check-circle g-state-text g-state-success"
                //        break;
                //    case 300:
                //        text = "jres:33000142"; //RC 33000142 : Připraven
                //        icon = "fa-exclamation-triangle g-state-text g-state-info";
                //        break;
                //    case 500:
                //        text = "jres:33000140";
                //        icon = "fa-exclamation-triangle g-state-text g-state-warning";
                //        break;
                //    case 600:
                //        text = "jres:33000141" //RC 33000141 : Návrh
                //        icon = "fa-exclamation-triangle g-state-text g-state-info";
                //        break;
                //    default:
                //        text = "jres:33000143" //RC 33000143 : Zrušen
                //        icon = "fa-times-circle g-state-text g-state-error"
                //        break;
                //}
                //return { icon: icon, text: text, tooltip: text };
            }
        })
    }

    function createDatOdOrDoColumn(gridFormat: Gordic.Data.GridFormat) {
        gridFormat.addIconColumn({
            name: "platnost",
            caption: "Platnost",
            iconTemplate: (row) => {
                var icon = "gi-time";
                var color = "";
                var text = "";
                switch (row.platnost) {
                    case GAdmGlobals.PlatnostEnum.platne:
                        color = "g-state-success";
                        text = "jres:33000182"
                        break;
                    case GAdmGlobals.PlatnostEnum.predPlatnosti:
                        color = "g-state-info";
                        text = "jres:33000183"
                        break;
                    case GAdmGlobals.PlatnostEnum.poPlatnosti:
                        color = "g-state-warning";
                        text = "jres:33000184";
                        break;
                    default:
                        return { icon: "", text: "" }
                }
                return { icon: "{0} g-state-text {1}".format(icon, color), text: text };
            }
        })
    }

    function createZamekColumn(gridFormat: Gordic.Data.GridFormat) {
        gridFormat.addIconColumn({
            name: "zamek",
            caption: "Zákaz editace",
            iconTemplate: (row) => {
                var icon = "";
                var text = "";
                switch (row.zamek) {
                    case GAdmGlobals.ZamekEnum.uzamceno:
                        icon = "fa-lock g-state-text g-state-warning"
                        text = "jres:33000187"; //RC 33000187 : Editace není povolena
                        break
                }
                return { icon: icon, text: text }
            }
        })
    }

    function createAkceColumn(gridformat: Gordic.Data.GridFormat) {
        gridformat.addIconColumn({
            name: "typ_op",
            caption: "Operace",
            iconTemplate: (row) => {
                var text: string = "";
                var icon: string = "";
                switch (row.m_typ_akce) {
                    case "V":
                        icon = "gi-detail";
                        text = "jres:33000188"; //RC 33000188 : Zobrazení
                        break;
                    case "E":
                        icon = "gi-pencil";
                        text = "jres:32000120";
                        break;
                    case "P":
                        icon = "gi-komentar";
                        text = "jres:29930689";
                        break;
                    case "N":
                        icon = "gi-star";
                        text = "jres:33000189" //RC 33000189 : Založení
                }
                return { icon: icon, text: text, tooltip: text }
            }
        })
    }

    function createClassicColumn(column: Gordic.General.ApplicationInterface.GDataFieldDescription, columns: Gordic.Data.GridFormat) {
        var v_char_width = 8;
        var v_coll_add = 2;
        var v_char_caption_width = 9.3;
        var v_caption_add = 2;
        var v_sirka = 0;
        var v_sirka_nadpisu = 0;
        var v_maxCollChars = 50;
        var v_caption = column.field_caption || "";
        switch (column.field_base_type?.toString()) {
            case "BOOLEAN":
                v_sirka = 10;
                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                if (v_sirka_nadpisu > v_sirka)
                    v_sirka = v_sirka_nadpisu;
                columns.addBooleanColumn({
                    name: column.field_name || "",
                    caption: column.field_caption || "",
                    width: v_sirka,
                    fragment: ""
                })
                break
            case "TEXT":
                v_sirka = column.field_max_data_size || v_maxCollChars;
                if (v_sirka > v_maxCollChars)
                    v_sirka = v_maxCollChars;
                if (v_sirka < 10)
                    v_sirka = 10;
                v_sirka = (v_sirka + v_coll_add) * v_char_width;
                v_sirka_nadpisu = ((column.field_caption || "").length + v_caption_add) * v_char_caption_width;
                if (v_sirka_nadpisu > v_sirka)
                    v_sirka = v_sirka_nadpisu;

                columns.addTextColumn({
                    name: column.field_name || "",
                    caption: column.field_caption || "",
                    width: v_sirka,
                    fragment: ""
                });
                break;
            case "DATETIME":
                //var v_sirka = 16; JKlusacek - zmněna kvůli datumu - nebylo vidět celé
                var v_sirka = 19;
                v_sirka = v_sirka * v_char_width;
                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                if (v_sirka_nadpisu > v_sirka)
                    v_sirka = v_sirka_nadpisu;
                columns.addDateTimeColumn({
                    name: column.field_name || "",
                    caption: column.field_caption || "",
                    width: v_sirka,
                    fragment: ""
                });
                break;
            case "DATE":
                var v_sirka = 6;
                v_sirka = v_sirka * v_char_width;
                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                if (v_sirka_nadpisu > v_sirka)
                    v_sirka = v_sirka_nadpisu;
                columns.addDateColumn({
                    name: column.field_name || "",
                    caption: column.field_caption || "",
                    width: v_sirka,
                    fragment: ""
                });
                break;
            case "NUMBER":
                var v_sirka = 7;
                v_sirka = v_sirka * v_char_width;
                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                if (v_sirka_nadpisu > v_sirka)
                    v_sirka = v_sirka_nadpisu;
                columns.addNumberColumn({
                    name: column.field_name || "",
                    caption: column.field_caption || "",
                    width: v_sirka,
                    fragment: ""
                });
                break;
            case "DECIMAL":
                var v_sirka = 15;
                v_sirka = v_sirka * v_char_width;
                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                if (v_sirka_nadpisu > v_sirka)
                    v_sirka = v_sirka_nadpisu;
                columns.addDecimalColumn({
                    name: column.field_name || "",
                    caption: column.field_caption || "",
                    width: column.field_size || 150,
                    fragment: ""
                });
                break;
        }
    }

    function getScopedObj(scope, str: string) {
        let obj = scope, arr;
        try {
            arr = str.split(/[\[\]\.]/) // split by [,],.
                .filter(el => el)             // filter out empty one
                .map(el => el.replace(/^['"]+|['"]+$/g, '')); // remove string quotation
            arr.forEach(el => obj = obj[el])
        } catch (e) {
            obj = undefined;
        }
        return obj;
    } // getScopedObj
}